export {TripDetailLayout, type TripDetailLayoutProps} from "./trip-detail-layout";
